import React from 'react'
import DetailsReporting from '../../DetailsReporting'

//@ts-ignore
const Reports = ({ data, ID, hash }) => <DetailsReporting data={data} ID={ID} hash={hash} type="Loan" />

Reports.defaultProps = {
  data: [],
}

export default Reports
